import type { JSX } from "react";
import { useI18n } from "../i18n/I18nContext";
import styles from "./ui.module.css";

/** Properties of {@link Loading}. */
export interface LoadingProps {
  /**
   * Whether the text is only announced, not shown, for example next to a {@link Skeleton} that
   * shows the loading state visually.
   */
  readonly visuallyHidden?: boolean | undefined;
}

/**
 * Loading indicator announced to screen readers (polite live region, S-1).
 *
 * @param props - Component properties.
 * @returns The indicator element.
 */
export function Loading(props: LoadingProps = {}): JSX.Element {
  const { t } = useI18n();
  const indicator = (
    <p
      className={props.visuallyHidden === true ? "visually-hidden" : styles["muted"]}
      role="status"
      aria-live="polite"
    >
      {t("app.loading")}
    </p>
  );

  return indicator;
}
